var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import LicenseService from '../../../api/LicenseService';
import ClientService from '../../../api/ClientService';
var initFormData = {
    group_id: 0,
    keywords: '',
};
var SeeBindCustomers = (function (_super) {
    __extends(SeeBindCustomers, _super);
    function SeeBindCustomers() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = __assign({}, initFormData);
        _this.groups = [];
        return _this;
    }
    SeeBindCustomers.prototype.created = function () {
        this.service = LicenseService.getInstance();
        this.clientService = ClientService.getInstance();
        this.getGroups();
    };
    SeeBindCustomers.prototype.mounted = function () {
        this.search();
    };
    SeeBindCustomers.prototype.getGroups = function () {
        var _this = this;
        this.clientService.getGroups({ isAll: 1 }).then(function (res) {
            _this.groups = res.data.data || [];
        });
    };
    SeeBindCustomers.prototype.search = function () {
        this.$emit('search', __assign({}, this.formData));
    };
    SeeBindCustomers = __decorate([
        Component({
            components: {}
        })
    ], SeeBindCustomers);
    return SeeBindCustomers;
}(Vue));
export default SeeBindCustomers;
